/**
 * Stato di pubblicazione di un articolo.
 *
 * Nell'elenco c'erano due colonne con "Si" e "No" — `approvato` ed `evidenza`
 * — e nessun modo di distinguere un articolo davvero online da uno approvato
 * con data futura: `approvato = 1` bastava a far scrivere "Pubblicato: Si".
 * Lo stato "programmato" si ricava confrontando la data con adesso.
 */
export interface StatoArticolo {
  codice: 'pubblicato' | 'programmato' | 'bozza';
  etichetta: string;
}

const STATI: Record<StatoArticolo['codice'], string> = {
  pubblicato: 'Pubblicato',
  programmato: 'Programmato',
  bozza: 'Bozza',
};

/** `data` e' un timestamp in secondi, come lo manda il backend. */
export function statoArticolo(
  articolo: { approvato?: string | number | null; data?: number | null },
  adessoInSecondi: number = Math.floor(Date.now() / 1000)
): StatoArticolo {
  const approvato = String(articolo.approvato ?? '0') === '1';

  if (!approvato) {
    return { codice: 'bozza', etichetta: STATI.bozza };
  }

  if (articolo.data != null && articolo.data > adessoInSecondi) {
    return { codice: 'programmato', etichetta: STATI.programmato };
  }

  return { codice: 'pubblicato', etichetta: STATI.pubblicato };
}
